import React, { Component } from 'react'

function ConvertQuantity(q, c, f, mode) {

  if (q && c != undefined) {

    if (mode === 1) {

      return Number((q * c).toFixed(f))

    } else if (mode === 2) {

      return Number((q / c).toFixed(f))

    }


  }

}
export default ConvertQuantity;
